import { render, staticRenderFns } from "./Venue.vue?vue&type=template&id=42b19f7c&"
import script from "./Venue.vue?vue&type=script&lang=js&"
export * from "./Venue.vue?vue&type=script&lang=js&"
import style0 from "./Venue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VAlert,VContainer,VDivider})
